<template>
  <v-footer dark padless>
    <v-card flat tile class="secondary white--text text-center">
      <v-card-text>
        <v-btn
          v-for="(icon, i) in icons"
          :key="i"
          class="mx-4 white--text"
          :href="icon.link"
          target="_blank"
          icon
        >
        <a-icon :type="icon.text" :theme="icon.theme" style="font-size: 30px;"/>
        </v-btn>
      </v-card-text>

      <v-card-text class="white--text pt-0">
        Copyright © 2022 - {{ new Date().getFullYear() }} Baoding Zenow Intelligent Technology Co., Ltd All Rights Reserved.
      </v-card-text>

      <!-- <v-divider></v-divider> -->

      <v-card-text class="white--text pt-0">

        <div style="width: 100%; display: flex; justify-content: center;">
          <div class="mr-2">
            <a href="https://beian.miit.gov.cn/" target="_blank" style="color: #afafaf;text-decoration:none; font-size: smaller;">冀ICP备2024088291号-1</a>           
          </div>
          <div style="display: flex;justify-content: center;">
            <v-img src="~@/assets/img/beian.png" max-width="12px" contain/>
            <div class="ml-1">
              <a href="https://beian.mps.gov.cn/#/query/webSearch?code=13065202000522" rel="noreferrer" target="_blank" style="color: #afafaf;text-decoration:none;font-size: smaller;">冀公网安备13065202000522</a>
            </div>  
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<style scoped>
.v-card {
  width: 100%;
}
</style>

<script>
export default {
  data: () => ({
    icons: [
      {
        text: "wechat",
        theme: "filled",
        link: "",
      },
      {
        text: "dingtalk-circle",
        theme: "filled",
        link: "",
      },
      {
        text: "qq",
        theme: "outlined",
        link: "",
      },
      {
        text: "weibo-circle",
        theme: "filled",
        link: "",
      },      
    ],
  }),
};
</script>
